export default "__VITE_ASSET__Cm33BQNv__";